import http, { requestConfig } from "../../http-wiki";

const RESOURCE_NAME = "page";

const get = (path: any, languageCode: any) => {
  return http.get(`${RESOURCE_NAME}/getbypath?path=${path}&languageCode=${languageCode}`, requestConfig());
};

const getPages = (id:any) => {
  return http.get(`${RESOURCE_NAME}/gettree?id=${id ? id : -1}`, requestConfig());
};

const WikiService = {
    get,
    getPages
};
export default WikiService;
